import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ATS_CALL_FROM_LOAD_ERROR_MESSAGE } from '@/constants/atsCalls';
import {
  readSelectedCallFrom,
  saveSelectedCallFrom
} from '@/services/ats/callFromStorage';
import { resolveSelectedCallFrom } from '@/utils/resolveSelectedCallFrom';
import { fetchAtsCallFromListThunk } from './atsCallFromThunks';

export interface IAtsCallFromState {
  /** Список линий, с которых можно совершить исходящий звонок. */
  items: string[];
  /** Выбранная линия. Инициализируется сохранённым значением до загрузки списка. */
  selected: string | null;
  isLoading: boolean;
  /** Первая успешная загрузка завершена — повторно список не запрашиваем. */
  hasLoaded: boolean;
  errorMessage: string | null;
}

const initialState: IAtsCallFromState = {
  items: [],
  selected: readSelectedCallFrom(),
  isLoading: false,
  hasLoaded: false,
  errorMessage: null
};

const atsCallFrom = createSlice({
  name: 'atsCallFrom',
  initialState,
  reducers: {
    setCallFrom(state, action: PayloadAction<string>) {
      // Выбрать можно только линию из актуального списка
      if (!state.items.includes(action.payload)) return;

      state.selected = action.payload;
      saveSelectedCallFrom(action.payload);
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAtsCallFromListThunk.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })
      .addCase(fetchAtsCallFromListThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasLoaded = true;
        state.errorMessage = null;
        state.items = action.payload;

        const nextSelected = resolveSelectedCallFrom(
          action.payload,
          state.selected
        );

        if (nextSelected === state.selected) return;

        state.selected = nextSelected;

        if (nextSelected !== null) {
          saveSelectedCallFrom(nextSelected);
        }
      })
      .addCase(fetchAtsCallFromListThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage =
          action.payload?.message ?? ATS_CALL_FROM_LOAD_ERROR_MESSAGE;
      });
  }
});

export const { setCallFrom } = atsCallFrom.actions;
export { fetchAtsCallFromListThunk };
export default atsCallFrom.reducer;
